import React from 'react'

import FileView from 'components/FileView/FileView'
import { ErrorBoundary } from 'core/ErrorBoundary/ErrorBoundary'

import { ErrorWrapper, TextFileContent, Wrapper } from './FileContents.styles'
import { NoContent } from './NoContent'
import { getTextFileTestId } from './utils'

interface TextFileViewerProps {
  fileExtension: string
  signedUrl?: string
}

export const TextFileViewer = ({ fileExtension, signedUrl }: TextFileViewerProps) => {
  if (!signedUrl) return <NoContent />

  return (
    <Wrapper>
      <TextFileContent data-testid={getTextFileTestId(fileExtension)}>
        <ErrorBoundary
          fallback={
            <ErrorWrapper>
              <h2>Error loading file</h2>
            </ErrorWrapper>
          }
        >
          <FileView fileExtension={fileExtension} url={signedUrl} />
        </ErrorBoundary>
      </TextFileContent>
    </Wrapper>
  )
}
